import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import * as snackBarActions from '../../redux/actions/snackBarActions';

//global snack bar. implemented at app.js page level.
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

//state is managed by uireducer(setting open / false)
export default function CustomizedSnackbars(props) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const state = useSelector((state) => state.ui.snackBar);

	const handleClose = (event, reason) => {
		//preventing close of snack bar when clicked else where on the page
		if (reason === 'clickaway') {
			return;
		}
		dispatch(snackBarActions.clearSnackBar());
	};

	return (
		<div className={classes.root} data-cy="snack-bar">
			<Snackbar
				open={state.open}
				autoHideDuration={8500}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<Alert onClose={handleClose} severity={state.severity}>
					{state.message}
				</Alert>
			</Snackbar>
		</div>
	);
}
